import {
  IonCard,
  IonCardContent,
  IonCol,
  IonItem,
  IonRow,
  IonText,
  IonThumbnail,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { makePOSTRequest } from "../../request/rawRequest";
import { Video } from "../../types/video";

import "../generalCSS/stylesheet.css";
import "./List.css";
interface ContainerProps {
  idTheme: number;
  generique: boolean;
  id_videos: Array<any>;
  picture_url?: string;
  compID?: string;
}

const getVideosByTheme = async (id_videos: any) => {
  let vids: any = [];
  await makePOSTRequest("/videos", { _id: id_videos }).then((data) => {
    vids = data;
  });

  return vids;
};

const videoCard = (
  video: any,
  idTheme: number,
  id: any,
  href: string,
  picture_url?: string,
  compID?: string
) => {
  let finalHref =
    "auth/pole/" + href + "?theme=" + idTheme + "&id=" + video._id;

  if (compID !== undefined && compID.length > 0)
    finalHref += "&compID=" + compID;

  return (
    // <>
    //   {video._id}
    <IonCard
      key={id}
      href={finalHref}
      color="light"
      className="card card-theme "
    >
      <IonCardContent className="card-content background-video-card no-padding">
        <IonItem color="transparent">
          <IonThumbnail
            slot="start"
            style={{ marginTop: "0", marginBottom: "0" }}
            className="no-margin"
          >
            <img
              alt="vignette"
              src={
                video.picture_url
                  ? picture_url
                  : "https://cdn-icons-png.flaticon.com/512/2702/2702134.png"
              }
              style={{
                borderRadius: "100%",
              }}
            />
          </IonThumbnail>
          <div className="separator"></div>
          <IonText>
            <h5>
              {video.name}
              <span
                style={{ color: "green", fontSize: "30px", paddingLeft: 5 }}
              >
                {video.viewed && video.viewed === true ? "✔" : ""}
              </span>
            </h5>
          </IonText>
        </IonItem>
      </IonCardContent>
    </IonCard>
    // </>
  );
};

const viewedVideos = (videoList: Video[], idTheme: number) => {
  if (!videoList || videoList.length <= 0) return;
  return (
    <details>
      <summary>Vidéos vues</summary>
      {videoList.map((video, i) => {
        return videoCard(video, idTheme, i, "videogen");
      })}
    </details>
  );
};

const ListVideo: React.FC<ContainerProps> = ({
  idTheme,
  generique,
  id_videos,
  picture_url,
  compID,
}) => {
  const [videoLists, setvideoList] = useState<any[]>([]);

  const videoList: any[] = videoLists;
  const videoListViewed: Video[] = videoList.filter(
    (video) => video.viewed === true
  );
  const videoListNoViewed: any[] = videoList.filter(
    (video) => video.viewed === false
  );

  useEffect(() => {
    const videos = getVideosByTheme(id_videos);
    videos.then((data) => {
      let vids: any = [];
      for (let i = 0; i < data.length; i++) {
        vids.push(data[i]);
      }
      vids.sort((a: any, b: any) => a.index - b.index);
      setvideoList(vids);
    });
  }, []);

  return (
    <IonRow>
      <IonCol size="12" size-sm="12" size-lg="12">
        {generique ? viewedVideos(videoListViewed!, idTheme) : ""}
        {generique
          ? videoListNoViewed.map((video, i) => {
              return videoCard(
                video,
                idTheme,
                video._id,
                "videogen",
                "",
                compID
              );
            })
          : videoList.map((video, i) => {
              return videoCard(
                video,
                idTheme,
                video._id,
                "video",
                picture_url,
                compID
              );
            })}
      </IonCol>
    </IonRow>
  );
};

export default ListVideo;
